import { sentry } from 'common/helpers'
import cookie from 'js-cookie'


const sentryMiddleware = () => (store) => {
  let lastAction

  sentry.addEventProcessor((event = {}) => {
    const state = store.getState()

    event.extra = {
      lastAction,
      state,
      cookies: cookie.getJSON(),
      globals: window.__globals__,
      appConfig: window.__appConfig__,
      ...(event.extra || {}),
    }

    return event
  })

  return (next) => (action) => {
    sentry.captureBreadcrumb({
      category: 'redaction-action',
      message: action.type,
      data: action.payload,
    })

    lastAction = action
    return next(action)
  }
}


export default sentryMiddleware
